export default __webpack_public_path__ + "media/guidelines/custom-625a25af.png";